<template>
  <section class="nx-customers" id="partners">
    <div class="nx-customers-container">
      <!-- 能源客户 - 已隐藏 -->
      <div class="nx-customers-energy" v-if="false">
        <div class="nx-customers-header nx-animate-on-scroll">
          <p class="nx-customers-subtitle">{{ config?.customers?.energy?.subtitle }}</p>
          <h2 class="nx-customers-title">{{ config?.customers?.energy?.title }}</h2>
        </div>

        <div class="nx-energy-grid nx-animate-on-scroll" :class="{ 'nx-energy-single': (config?.customers?.energy?.list || []).length === 1 }">
          <div
            v-for="(logo, index) in (config?.customers?.energy?.list || [])"
            :key="'energy-' + index"
            class="nx-energy-logo nx-card"
          >
            <img :src="logo" alt="能源客户" />
          </div>
        </div>
      </div>

      <!-- 分隔线 - 已隐藏 -->
      <div class="nx-divider" v-if="false">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <!-- 其它行业客户案例 - 轮播展示 -->
      <div class="nx-customers-others nx-animate-on-scroll">
        <div class="nx-customers-header">
          <p class="nx-customers-subtitle">{{ config?.customers?.others?.subtitle }}</p>
          <h2 class="nx-customers-title">{{ config?.customers?.others?.title }}</h2>
        </div>

        <!-- 移动端查看更多按钮 -->
        <div class="nx-customers-more">
          <a href="javascript:void(0)" class="nx-customers-more-btn" @click="goToCustomerList">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 17L18 12L13 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 17L11 12L6 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>

        <!-- 轮播组件 - 桌面端使用轮播 -->
        <div class="nx-partners-carousel" v-if="partnerPages.length > 0">
          <el-carousel
           :autoplay="true"
            ref="carousel"
            :interval="4000"
            arrow="never"
            height="350px"
            class="partners-carousel desktop-carousel"
            @change="handleCarouselChange"
          >
            <el-carousel-item v-for="(page, pageIndex) in partnerPages" :key="pageIndex">
              <div class="partners-page">
                <div
                  v-for="(partner, index) in page"
                  :key="'partner-' + pageIndex + '-' + index"
                  class="partner-item"
                >
                  <div class="partner-inner">
                    <img :src="partner" alt="合作伙伴" />
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <!-- 轮播指示器单独一行 -->
          <div class="partners-indicators desktop-indicators">
            <span
              v-for="(page, index) in partnerPages"
              :key="'indicator-' + index"
              class="partners-indicator"
              :class="{ 'is-active': currentPage === index }"
              @click="currentPage = index"
            ></span>
          </div>

          <!-- 手机端静态网格 - 显示所有logo -->
          <div class="partners-mobile-grid">
            <div
              v-for="(partner, index) in mobilePartnerList"
              :key="'mobile-partner-' + index"
              class="partner-item"
            >
              <div class="partner-inner">
                <img :src="partner" alt="合作伙伴" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NxCustomers',
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      partnersPerPage: 20, // 每页显示20个（4行 x 5列）
      currentPage: 0,
      isMobile: window.innerWidth <= 768
    };
  },
  computed: {
    // 将合作伙伴列表分页 - 每页20个，4行5列布局
    partnerPages() {
      const list = this.config?.customers?.others?.list || [];
      const pages = [];
      for (let i = 0; i < list.length; i += this.partnersPerPage) {
        pages.push(list.slice(i, i + this.partnersPerPage));
      }
      return pages;
    },
    // 移动端显示的客户列表（限制数量）
    mobilePartnerList() {
      const list = this.config?.customers?.others?.list || [];
      return list.slice(0, 9); // 移动端只显示9个
    }
  },
  watch: {
    currentPage(newVal) {
      if (this.$refs.carousel) {
        this.$refs.carousel.setActiveItem(newVal);
      }
    }
  },
  mounted() {
    // 组件已挂载，配置由父组件传递
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    handleCarouselChange(index) {
      this.currentPage = index;
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    goToCustomerList() {
      // 在新窗口打开客户名单页面
      const url = window.location.origin + '/customer-list';
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }
};
</script>

<style scoped>
.nx-customers {
  position: relative;
  padding: 100px 30px;
  background: linear-gradient(180deg, #fafbfc 0%, #f5f7fa 100%);
}

.nx-customers-container {
  max-width: 1400px;
  margin: 0 auto;
}

.nx-customers-header {
  text-align: center;
  margin-bottom: 30px;
}

.nx-customers-subtitle {
  font-size: 1.2rem;
  color: var(--nx-blue-primary);
  font-weight: 500;
  letter-spacing: 0.3rem;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
  text-shadow: 0 0 20px rgba(25, 118, 210, 0.25);
}

.nx-customers-title {
  font-size: clamp(32px, 4.5vw, 48px);
  font-weight: 800;
  color: var(--nx-text-title);
  margin-bottom: 12px;
  text-shadow: 0 0 30px rgba(13, 71, 161, 0.15),
    0 0 60px rgba(59, 130, 246, 0.1);
  position: relative;
  display: inline-block;
}

.nx-customers-title::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(
    90deg,
    transparent,
    var(--nx-blue-primary),
    transparent
  );
  border-radius: 2px;
  box-shadow: 0 0 15px rgba(59, 130, 246, 0.6);
  animation: titleGlow 2s ease-in-out infinite;
}

.nx-energy-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.nx-energy-logo {
  padding: 30px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background:
    linear-gradient(145deg,
      rgba(255, 255, 255, 0.98) 0%,
      rgba(248, 250, 255, 0.95) 100%);
  backdrop-filter: blur(30px);
  border: 2px solid rgba(59, 130, 246, 0.18);
  border-radius: var(--nx-radius-lg);
  min-height: 180px;
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  position: relative;
  overflow: hidden;
  box-shadow:
    0 8px 30px rgba(59, 130, 246, 0.1),
    0 0 40px rgba(59, 130, 246, 0.05);
}

.nx-energy-logo::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at center, rgba(59, 130, 246, 0.05) 0%, transparent 70%),
    radial-gradient(circle at 80% 20%, rgba(139, 92, 246, 0.04) 0%, transparent 60%);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.nx-energy-logo:hover {
  border-color: rgba(59, 130, 246, 0.4);
  transform: translateY(-10px);
  box-shadow:
    0 16px 50px rgba(59, 130, 246, 0.18),
    0 0 70px rgba(59, 130, 246, 0.12);
}

.nx-energy-logo:hover::before {
  opacity: 1;
}

.nx-energy-logo img {
  max-width: 100%;
  height: auto;
  max-height: 160px;
  width: auto;
  object-fit: contain;
  opacity: 0.95;
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  filter: brightness(1);
}

.nx-energy-logo:hover img {
  opacity: 1;
  transform: scale(1.1);
  filter: brightness(1.1) drop-shadow(0 8px 20px rgba(59, 130, 246, 0.4));
}

/* 单张图片全屏展示 */
.nx-energy-single {
  grid-template-columns: 1fr;
  max-width: 1400px;
  margin: 0 auto 70px;
}

.nx-energy-single .nx-energy-logo {
  min-height: 600px;
  padding: 80px 60px;
  max-width: 100%;
  margin: 0 auto;
  border: none;
  background: transparent;
  box-shadow: none;
}

.nx-energy-single .nx-energy-logo::before {
  display: none;
}

.nx-energy-single .nx-energy-logo:hover {
  border: none;
  transform: none;
  box-shadow: none;
}

.nx-energy-single .nx-energy-logo img {
  max-height: 550px;
  max-width: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  opacity: 1;
  filter: brightness(1);
}

.nx-energy-single .nx-energy-logo:hover img {
  transform: none;
  filter: brightness(1);
}

.nx-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin: 100px 0;
}

.nx-divider span {
  height: 1px;
  background:
    linear-gradient(90deg,
      transparent 0%,
      #3b82f6 20%,
      #60a5fa 50%,
      #3b82f6 80%,
      transparent 100%);
  background-size: 200% 200%;
  flex: 1;
  box-shadow: 0 0 15px rgba(59, 130, 246, 0.4);
}

.nx-divider span:nth-child(2) {
  width: 80px;
  height: 3px;
  flex: none;
  background:
    linear-gradient(90deg,
      #3b82f6 0%,
      #60a5fa 50%,
      #3b82f6 100%);
  box-shadow: 0 0 20px rgba(59, 130, 246, 0.6);
}

/* 轮播容器 */
.nx-partners-carousel {
  position: relative;
  z-index: 1;
}

/* 桌面端轮播和指示器默认显示 */
.desktop-carousel,
.desktop-indicators {
  display: block;
}

.partners-carousel {
  width: 100%;
}

.partners-carousel :deep(.el-carousel__container) {
  /* 4行x75px + 3个行间距x10px + 上下padding 20px */
  height: 350px;
}

/* 隐藏默认指示器 */
.partners-carousel :deep(.el-carousel__indicators) {
  display: none;
}

/* 自定义指示器容器 */
.partners-indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  padding: 10px 0;
}

/* 自定义指示器样式 */
.partners-indicator {
  width: 32px;
  height: 3px;
  background: rgba(59, 130, 246, 0.3);
  border-radius: 2px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.partners-indicator:hover {
  background: rgba(59, 130, 246, 0.5);
}

.partners-indicator.is-active {
  width: 32px;
  background:
    linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);
  box-shadow: 0 0 12px rgba(59, 130, 246, 0.5);
}

/* 轮播页面 - 5列 x 4行网格布局 */
.partners-page {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(4, 1fr);
  gap: 10px;
  padding: 10px;
  height: 100%;
  align-content: center;
}

.partner-item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 75px;
  background:
    linear-gradient(145deg,
      rgba(255, 255, 255, 0.98) 0%,
      rgba(248, 250, 255, 0.95) 100%);
  backdrop-filter: blur(25px);
  border: 2px solid rgba(59, 130, 246, 0.15);
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow:
    0 6px 25px rgba(59, 130, 246, 0.1),
    0 0 35px rgba(59, 130, 246, 0.06);
}

.partner-item:hover {
  transform: translateY(-4px) scale(1.02);
  border-color: rgba(59, 130, 246, 0.4);
  box-shadow:
    0 12px 40px rgba(59, 130, 246, 0.18),
    0 0 60px rgba(59, 130, 246, 0.12);
}

.partner-inner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.partner-inner img {
  max-width: 100%;
  max-height: 55px;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  filter: brightness(1);
}

.partner-item:hover .partner-inner img {
  transform: scale(1.08);
  filter: brightness(1.1) drop-shadow(0 4px 12px rgba(59, 130, 246, 0.3));
}

/* 隐藏轮播箭头 */
.partners-carousel :deep(.el-carousel__arrow) {
  display: none;
}

/* 其它行业客户案例 - 静态网格展示 */
.nx-customers-others {
  display: block;
  position: relative;
  padding: 35px 30px;
  background:
    linear-gradient(145deg,
      rgba(255, 255, 255, 0.98) 0%,
      rgba(248, 250, 255, 0.95) 100%);
  backdrop-filter: blur(30px);
  border: none;
  border-radius: 20px;
  overflow: hidden;
  box-shadow:
    0 10px 40px rgba(59, 130, 246, 0.1),
    0 0 60px rgba(59, 130, 246, 0.05);
}

.nx-customers-others::before {
  display: none;
}

.nx-customers-others::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 20% 30%, rgba(59, 130, 246, 0.03) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(139, 92, 246, 0.03) 0%, transparent 50%);
  pointer-events: none;
}

.nx-customers-others .nx-customers-header {
  position: relative;
  z-index: 1;
  text-align: center;
  margin-bottom: 20px;
}

/* PC端隐藏查看更多按钮 */
.nx-customers-more {
  display: none;
}

/* 确保滚动动画可见状态下也没有边框 */
.nx-customers-others.nx-visible {
  border: none !important;
}

/* 其它行业客户网格布局 */
.nx-others-grid {
  position: relative;
  z-index: 1;
  max-width: 1400px;
  margin: 0 auto;
}

.nx-others-row {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.nx-others-row:last-child {
  margin-bottom: 0;
}

/* 不同行的特殊样式 */
.nx-others-row.row-first,
.nx-others-row.row-fourth {
  justify-content: center;
}

.nx-others-row.row-second {
  justify-content: center;
}

.nx-others-logo {
  flex: 0 0 auto;
  width: 200px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background:
    linear-gradient(145deg,
      rgba(255, 255, 255, 0.98) 0%,
      rgba(248, 250, 255, 0.95) 100%);
  backdrop-filter: blur(20px);
  border: 2px solid rgba(59, 130, 246, 0.15);
  border-radius: 14px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  position: relative;
  box-shadow:
    0 4px 15px rgba(59, 130, 246, 0.08),
    0 0 25px rgba(59, 130, 246, 0.05);
}

.nx-others-logo::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at center, rgba(59, 130, 246, 0.06) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.nx-others-logo:hover {
  border-color: rgba(59, 130, 246, 0.4);
  transform: translateY(-8px) scale(1.02);
  box-shadow:
    0 12px 35px rgba(59, 130, 246, 0.2),
    0 0 50px rgba(59, 130, 246, 0.15);
}

.nx-others-logo:hover::before {
  opacity: 1;
}

.nx-others-logo img {
  width: 100%;
  height: 100%;
  max-width: 180px;
  max-height: 80px;
  object-fit: contain;
  padding: 15px;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  filter: brightness(1);
}

.nx-others-logo:hover img {
  transform: scale(1.08);
  filter: brightness(1.1) drop-shadow(0 4px 12px rgba(59, 130, 246, 0.3));
}

/* 响应式设计 */
@media (max-width: 1400px) {
  .nx-others-logo {
    width: 180px;
    height: 90px;
  }

  .nx-others-logo img {
    max-width: 160px;
    max-height: 70px;
  }
}

@media (max-width: 1200px) {
  .nx-customers-others {
    padding: 30px 28px;
  }

  .partners-page {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(5, 1fr);
    gap: 10px;
    padding: 10px;
  }

  .partner-item {
    min-height: 70px;
  }

  .partner-inner img {
    max-height: 50px;
  }

  .partners-carousel :deep(.el-carousel__container) {
    /* 5行x70px + 4个行间距x10px + 上下padding 20px */
    height: 410px;
  }
}

@media (max-width: 768px) {
  .nx-customers {
    padding: 70px 20px;
  }

  .nx-customers-others {
    padding: 25px 15px;
  }

  .nx-customers-others .nx-customers-header {
    margin-bottom: 18px;
  }

  /* 移动端查看更多按钮 */
  .nx-customers-more {
    display: block;
    position: absolute;
    top: 95px;
    right: 15px;
    z-index: 10;
  }

  .nx-customers-more-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 14px;
    background: linear-gradient(135deg, #e3f2fd 0%, #f0f7ff 100%);
    border: 1.5px solid rgba(25, 118, 210, 0.2);
    color: #1976d2;
    text-decoration: none;
    border-radius: 10px;
    transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
    box-shadow:
      0 2px 8px rgba(25, 118, 210, 0.08),
      inset 0 1px 2px rgba(255, 255, 255, 0.8);
    cursor: pointer;
  }

  .nx-customers-more-btn:hover {
    background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
    border-color: transparent;
    color: #fff;
    transform: translateX(4px);
    box-shadow:
      0 4px 15px rgba(25, 118, 210, 0.25),
      inset 0 0 0 transparent;
  }

  .nx-customers-more-btn svg {
    width: 16px;
    height: 16px;
    transition: transform 0.3s ease;
  }

  .nx-customers-more-btn:hover svg {
    transform: translateX(2px);
  }

  /* 手机端隐藏桌面轮播和指示器 */
  .desktop-carousel,
  .desktop-indicators {
    display: none !important;
  }

  /* 手机端显示所有logo的网格 */
  .partners-mobile-grid {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    padding: 10px;
    overflow: visible;
  }

  .partners-mobile-grid .partner-item {
    min-height: 65px;
  }

  .partners-mobile-grid .partner-inner {
    padding: 8px;
  }

  .partners-mobile-grid .partner-inner img {
    max-height: 45px;
  }

  .partners-page {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(7, 1fr);
    gap: 10px;
    padding: 10px;
  }

  .partner-item {
    min-height: 65px;
  }

  .partner-inner {
    padding: 8px;
  }

  .partner-inner img {
    max-height: 45px;
  }

  .partners-carousel :deep(.el-carousel__container) {
    /* 7行x65px + 6个行间距x10px + 上下padding 20px（移动端轮播隐藏，保持一致） */
    height: 535px;
  }

  .partners-carousel :deep(.el-carousel__arrow) {
    width: 48px;
    height: 48px;
  }

  .partners-carousel :deep(.el-carousel__arrow i) {
    font-size: 18px;
  }

  .partners-carousel :deep(.el-carousel__indicator .el-carousel__button) {
    width: 32px;
    height: 3px;
  }

  .partners-carousel :deep(.el-carousel__indicator.is-active .el-carousel__button) {
    width: 32px;
  }
}

@media (max-width: 480px) {
  /* 小屏手机优化网格 */
  .partners-mobile-grid {
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 8px !important;
    padding: 8px !important;
    overflow: visible !important;
  }

  .partners-mobile-grid .partner-item {
    min-height: 60px !important;
  }

  .partners-mobile-grid .partner-inner {
    padding: 6px !important;
  }

  .partners-mobile-grid .partner-inner img {
    max-height: 40px !important;
  }

  .partners-page {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(10, 1fr);
    gap: 8px;
    padding: 8px;
  }

  .partner-item {
    min-height: 60px;
  }

  .partner-inner {
    padding: 6px;
  }

  .partner-inner img {
    max-height: 40px;
  }

  .partners-carousel :deep(.el-carousel__container) {
    /* 10行x60px + 9个行间距x8px + 上下padding 16px（移动端轮播隐藏，保持一致） */
    height: 688px;
  }
}

/* 默认隐藏手机端网格 */
.partners-mobile-grid {
  display: none;
}

@media (max-width: 1200px) {
  .nx-energy-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
  }
}

@media (max-width: 768px) {
  .nx-customers {
    padding: 70px 20px;
  }

  .nx-energy-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .nx-energy-logo {
    padding: 24px 18px;
    min-height: 140px;
  }

  .nx-energy-logo img {
    max-height: 120px;
  }

  /* 单张图片移动端样式 */
  .nx-energy-single {
    max-width: 100%;
    padding: 0;
  }

  .nx-energy-single .nx-energy-logo {
    min-height: 350px;
    padding: 40px 20px;
    border: none;
    background: transparent;
    box-shadow: none;
  }

  .nx-energy-single .nx-energy-logo::before {
    display: none;
  }

  .nx-energy-single .nx-energy-logo:hover {
    border: none;
    transform: none;
    box-shadow: none;
  }

  .nx-energy-single .nx-energy-logo img {
    max-height: 300px;
    width: auto;
    height: auto;
  }

  .nx-divider {
    margin: 60px 0;
  }

  .nx-customers-others {
    padding: 50px 20px;
  }
}

/* 标题光效动画 */
@keyframes titleGlow {
  0%, 100% {
    width: 60px;
    opacity: 0.6;
  }
  50% {
    width: 120px;
    opacity: 1;
  }
}
</style>
